import React from 'react';
import './UnderConstructionApp.css';

function UnderConstructionApp() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="images/logo.png" className="App-logo" alt="logo" />
        <h1>The 5th 2.0</h1>
        <p>
          We're working on something new, something fresh...
        </p>
        <a
          className="App-link"
          href="https://the5th.azurewebsites.net/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Go back to the current 5th version
        </a>
      </header>
    </div>
  );
}

export default UnderConstructionApp;
